// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
header,
footer {
  background-color: #90CAFC;
}

.current-floor-name {
  padding-right: 20px;
}

.floor-name-label {
  font-size: small;
  color: rgba(13, 13, 13, 0.591);
  padding-bottom: 15px;
}

.floor-name {
  padding-top: 5px;
  font-size: medium;
  font-weight: bold;
  color: black;
}

.page-title {
  font-size: large;
}

.sub-header {
  background-color: #CCE2F5;
}

.edit-mode {
  color: blue;
}

.bookmark-img {
  width: 16px;
  top: 5px;
  left: 2px;
  cursor: pointer;
}

.report-button {
  background-color: #90CAFC;
  min-width: max-content;
}

.main-area {
  background-color: white;
}

.loading {
  background-color: white;
}

.all-partitions {
  background-color: whitesmoke;
}

.tenant-name {
  background-color: skyblue;
  font-size: large;
}

.wrap {
  display: flex;
  flex-wrap: wrap;
}

.card {
  padding-left: 10px;
  padding-top: 10px;
}

::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {
  background: inherit;
}

.pull-down {
  padding-top: 20px;
}

.meter-card-list-component-all {
  flex-wrap: wrap;
}

.meter-card-list-component-main {
  flex: 1;
  height: 94vh;
}

.main-area {
  height: 100%;
  overflow-y: auto;
  background-color: white;
}

.menu-list {
  height: 100%;
}

/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
::ng-deep .mat-tab-label {
  background-color: azure;
}

/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
::ng-deep .mat-tab-labels {
  background-color: azure;
}

.footer {
  width: 100%;
  bottom: 0; /*下に固定*/
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/meter-card-list/meter-card-list.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;EAEI,yBCHa;ADIjB;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AACJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACC,WAAA;EACA,QAAA;EACA,SAAA;EACG,eAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,4BAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,eAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,OAAA;EACA,YAAA;AADJ;;AAIA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA,0HAAA;AACA;EACI,uBAAA;AADJ;;AAIA,0HAAA;AACA;EACI,uBAAA;AADJ;;AAIA;EACI,WAAA;EAEA,SAAA,EAAA,OAAA;EACA,eAAA;AAFJ","sourcesContent":["@import \"variables\";\nheader,\nfooter{\n    background-color: $main-backgroud;\n}\n\n.current-floor-name{\n    padding-right: 20px;\n}\n\n.floor-name-label{\n    font-size: small;\n    color: rgba(13, 13, 13, 0.591);\n    padding-bottom: 15px;\n}\n\n.floor-name{\n    padding-top: 5px;\n    font-size: medium;\n    font-weight: bold;\n    color: black;\n}\n\n\n.page-title{\n    font-size: large;\n}\n\n.sub-header{\n    background-color: #CCE2F5;\n}\n\n.edit-mode{\n    color: blue;\n}\n\n.bookmark-img{\n\twidth: 16px;\n\ttop: 5px;\n\tleft: 2px;\n    cursor:pointer;\n}\n\n.report-button{\n    background-color: #90CAFC;\n    min-width: max-content;\n}\n\n.main-area{\n    background-color:white;\n}\n\n.loading{\n    background-color:white;\n}\n\n.all-partitions{\n    background-color: whitesmoke;\n}\n\n.tenant-name{\n    background-color: skyblue;\n    font-size: large;\n}\n\n.wrap {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.card {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {\n    background: inherit;\n}\n\n.pull-down {\n    padding-top: 20px\n}\n\n// フッターを下に固定するための修正\n.meter-card-list-component-all {\n    flex-wrap: wrap;\n}\n\n.meter-card-list-component-main {\n    flex: 1;\n    height: 94vh;\n}\n\n.main-area {\n    height: 100%;\n    overflow-y: auto;\n    background-color: white;\n}\n\n.menu-list {\n    height: 100%;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n::ng-deep .mat-tab-label {\n    background-color:azure;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n::ng-deep .mat-tab-labels {\n    background-color:azure;\n}\n\n.footer {\n    width: 100%;\n    // position: absolute;/*←絶対位置*/\n    bottom: 0; /*下に固定*/\n    position: fixed;\n}","$main-backgroud: #90CAFC;\n// 本番（PRD）：背景色を薄青（#90CAFC）にする\n// STG：背景色を薄緑（#66cdaa）にする\n// DEV：背景色を黄色（#ffd700）にする\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
